// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "64cdecf",
    "hash": "64cdecf",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "64cdecf",
    "semverString": null,
    "timestamp": 1777781096194,
    "dateStr": "Sun May 03 2026 04:04:56 GMT+0000 (Coordinated Universal Time)"
};
